<template>
    <div>
         <b-row class="toolbar-ptc">
            <b-col>
                <router-link :to="{ name: 'member_info_list', params: { search:$route.params.search } }" class="btn btn-ptc1" tag="button">返回</router-link>
            </b-col>
            <b-col class="text-center title">會員管理 / 會員查詢 / 點數兌換票券紀錄({{this.$route.params.membername}})</b-col>
            <b-col>
                <div class="text-right">
                    <b-btn class="btn btn-ptc1" v-b-toggle.collapse1>查詢</b-btn>
                </div>
            </b-col>
        </b-row>
        <div id="func-content">
            <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px;">
                <b-card class="bg-default-card">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="p-4 box-shadow" header="Form Elements">
                                <div class="row">
                                    <label class="control-label col-md-2">兌換日期區間：</label>
                                    <div class="col-md-3">
                                        <input type="date" class="form-control" v-model="model.sdate" max="9999-12-31" @input="changeDate($event, 1)" v-on:keydown="keydownDate($event, 1)">
                                    </div>
                                    <label class="control-label">至</label>
                                    <div class="col-md-3">
                                        <input type="date" class="form-control" v-model="model.edate" max="9999-12-31" @input="changeDate($event, 2)" v-on:keydown="keydownDate($event, 2)">
                                    </div>
                                    <div class="col-md-3">
                                        <button type="button" class="btn btn-warning text-white" @click="search()">查詢</button>
                                        <button type="button" class="btn btn-warning text-white" @click="reset()">重設</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-card>
            </b-collapse>
            <!-- First Basic Table Ends Here-->
            <!-- Second Data Table Starts Here-->
            <b-card class="bg-default-card">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="p-4 box-shadow" header="Form Elements">
                            <div class="table-responsive">
                                <table id="mytable" class="table table-bordred table-striped">
                                    <thead>
                                        <tr>
                                            <th>兌換日期</th>
                                            <th>兌換券名稱</th>
                                            <th>單張點數</th>
                                            <th>張數</th>
                                            <th>使用點數</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="v in Datalist" :key="v.CreatedAt">
                                            <td>{{v.CreatedAt}}</td>
                                            <td>{{v.Name}}</td>
                                            <td>{{v.Bonus}}</td>
                                            <td>{{v.Count}}</td>
                                            <td>{{v.AllBonus}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="row" style="padding: 0 1rem">
                                <b-pagination size="md" :total-rows="model.totalrows" v-model="model.currentPage" :per-page="model.rows" @change="getmemberexchangepointlist" :value="model.currentPage"></b-pagination>
                                <label style="margin:8px">{{model.startRowNum}}到{{model.endRowNum}}，總共 {{model.totalrows}}筆</label>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card>
            <!-- second row ends here -->
            <!-- Fourth Basic Table Starts Here-->
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import VueForm from 'vue-form'
import options from 'validations'
import axios from 'axios'
import {API_URL} from '../../../store/root.js'
import miniToastr from 'mini-toastr'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
Vue.use(VueForm, options)
export default {
  name: 'add_user',
  data () {
    return {
      formstate: {},
      Datalist: [],
      sdateInvalid: false,
      edateInvalid: false,
      model: {
        sdate: '',
        edate: '',
        currentPage: 0,
        perPage: 0,
        rows: 20,
        totalrows: 0,
        startRowNum: 0,
        endRowNum: 0
      },
      old_file: ''
    }
  },
  methods: {
    changeDate (e, type) {
      // 日期變更事件
      if (type === 1) {
        this.sdateInvalid = e.target.validity.badInput
      } else {
        this.edateInvalid = e.target.validity.badInput
      }
    },
    keydownDate (e, type) {
      // 日期輸入事件
      if (type === 1) {
        this.sdateInvalid = e.target.validity.badInput
      } else {
        this.edateInvalid = e.target.validity.badInput
      }
    },
    search () {
      this.model.currentPage = 1
      this.getmemberexchangepointlist(1)
    },
    getmemberexchangepointlist: function (currentPage) {
      if (this.$route.params.memberid === undefined) {
        this.$router.push({ name: 'member_info_list' })
        return
      }
      var edate = '9999-12-31'
      if (this.model.edate !== '') {
        edate = this.model.edate
      }
      if (this.model.sdate > edate) {
        miniToastr.error('請選擇正確的兌換日期區間')
        return
      }
      if (this.sdateInvalid || this.edateInvalid) {
        miniToastr.error('日期格式輸入錯誤，請重新輸入')
        return
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/member/swapGiftCertificateHistories/v1', {
        memberid: this.$route.params.memberid,
        startdate: this.model.sdate,
        enddate: edate,
        toPage: parseInt(currentPage),
        perPage: parseInt(this.model.rows)
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.model.totalrows = (response.data.totalRows === undefined) ? 0 : response.data.totalRows
            this.Datalist = response.data.swapgiftcertificatelist
            this.model.startRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : this.model.rows * (this.model.currentPage - 1) + 1
            this.model.endRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : (this.model.rows > response.data.totalRows) ? response.data.totalRows : (this.model.currentPage * this.model.rows) >= response.data.totalRows ? response.data.totalRows : this.model.currentPage * this.model.rows
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$router.push('/login')
          } else {
            miniToastr.error(response.data.message, '查詢失敗')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          miniToastr.error(error.message, '查詢失敗')
          this.$parent.Loading = false
        })
    },
    reset () {
      this.setdate()
      this.model.currentPage = 1
      this.sdateInvalid = false
      this.edateInvalid = false
      this.getmemberexchangepointlist(1)
    },
    setdate () {
      var date = new Date()
      date.setMonth(date.getMonth() - 3)
      var year = date.getFullYear()
      var mon = date.getMonth() + 1
      var day = date.getDate()

      if (mon < 10) {
        mon = '0' + mon
      }
      if (day < 10) {
        day = '0' + day
      }
      this.model.sdate = year + '-' + mon + '-' + day
      this.model.edate = ''
    }
  },
  mounted: function () {

  },
  destroyed: function () {

  },
  beforeMount: function () {
    this.setdate()
    this.getmemberexchangepointlist(1)
  },
  filters: {
    formatDate: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      var hour = d.getHours() < 10 ? '0' + d.getHours() : '' + d.getHours()
      var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : '' + d.getMinutes()
      var seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : '' + d.getSeconds()
      if (month < 10) {
        month = '0' + month
      }
      return year + '/' + month + '/' + day + ' ' + hour + ':' + minutes + ':' + seconds
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F07') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({name: 'name'})
    }
  }
}
</script>
<style scoped>
    .box-shadow {
        box-shadow: 0px 0px 1px 1px #cfcfcf;
    }
</style>



// WEBPACK FOOTER //
// src/pages/member/info/ExchangeHistory.vue